module.exports = __webpack_public_path__ + "static/media/crying-emoji-svgrepo-com.53d830f0.svg";